export default "__VITE_PUBLIC_ASSET__bd979c00__"